import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import LabelledTextInput from '../components/LabelledTextInput';
import Button from '../components/Button';
import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';

import { SearchParams } from '../../lib/utils';

const fields = [
	{ name: 'email', placeHolder: 'EMAIL', inputWidth: 900, containerWidth: 950 },
	{ name: 'invitationCode', placeHolder: 'INVITATION CODE', inputWidth: 900, containerWidth: 950 },
];

export default class Signup extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.lostActivationCode = this.lostActivationCode.bind(this);

		this.state = {
			submitted: false,
		};
	}

	componentDidMount() {
		/* eslint-disable-next-line */
		const queryParams = this.props.location.search;

		const params = new SearchParams(queryParams);
		const email = params.get('email');
		const invitationCode = params.get('invitationCode');
		const first = params.get('first') || '';
		const last = params.get('last') || '';

		this.setState({
			email,
			invitationCode,
			first,
			last,
		});
	}

	validateField(field, value) {
		switch(field) {
			case 'email':
				return value.length > 0;
			case 'invitationCode':
				return value.length > 0;
			default:
				return false;
		}
	}

	onChange(name) {
		return (e) => {
			e.preventDefault();
			this.setState({ [name]: e.target.value, errorMessage: null });
		}
	}

	onSubmit(e) {
		e.preventDefault();

		/* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Activate Account Click');

		const errors = {};
		fields.forEach((field) => {
			if (this.validateField(field.name, this.state[field.name])) {
				delete errors[field.name];
			} else {
				errors[field.name] = true;
			}
		});
		if (Object.keys(errors).length > 0) {
			return this.setState({ errorMessage: 'Invalid email and/or invitation code.' });
		}

		axios.post('/api/account/activate', {
			email: this.state.email,
			invitationCode: this.state.invitationCode,
		}).then(({ data }) => {
			if (!data.success) {
				if (data.error === 'account-doesnt-exist') {
					return this.setState({ errorMessage: 'Sorry, there is no existing account associated with this email address. Please enter a different email address, or call 1800 817 483.' });
				}

				if (data.message === 'You must specify a key value') {
					return this.setState({ submitted: true });
				}

				const errorMessage = data.error || data.message || 'Error encountered.'
				this.setState({ errorMessage });
			} else {
				const {
					first,
					last,
					email,
					invitationCode,
				} = this.state;

				let activateUrl = `/setup-account?email=${email}`;
				if (invitationCode) activateUrl += `&invitationCode=${invitationCode}`;
				if (first) activateUrl += `&first=${first}`;
				if (last) activateUrl += `&last=${last}`;

				/* eslint-disable-next-line */
				return window.location.replace(activateUrl);
			}
		}).catch((err) => {
			this.setState({ errorMessage: err.message });
		});
	}

	lostActivationCode () {
		axios.post('/api/account/lost-activation-code', {
			email: this.state.email,
		}).then(({ data }) => {
			if (!data.success) {
				if (data.error === 'account-doesnt-exist') {
					return this.setState({ errorMessage: 'Sorry, there is no existing account associated with this email address. Please enter a different email address, or call 1800 817 483.' });
				}

				if (data.message === 'You must specify a key value') {
					return this.setState({ submitted: true });
				}

				const errorMessage = data.error || data.message || 'Error encountered.'
				this.setState({ errorMessage });
			} else {
				this.setState({ submitted: true });
			}
		}).catch((err) => {
			this.setState({ error: err });
		});
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Activate"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Activate' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{!this.state.submitted ? (
						<MessageSection
							style={{ marginTop: '50px' }}
							header="Activate your blueshyft account"
							paragraph1="Please confirm or enter the 12-digit code included in your invitation email"
						/>
					) : (
						<MessageSection
							header="Activation code has been re-sent"
							paragraph1="Please check your emails (and your spam folder) for an email from support@blueshyft.com.au."
							paragraph2="Having trouble? Call blueshyft support on 1800 817 483."
						/>
					)}
					{this.state.errorMessage ? (
						<div style={{ display: 'flex', justifyContent: 'center', }}>
							<Notice
								color="red"
								text={this.state.errorMessage}
								width="750"
							/>
						</div>
					) : null}
					{!this.state.submitted ? (
						<CenteredContainer>
							<InputContainer>
								{fields.map((field, key) => {
									return (
										<Column key={key} style={field.containerWidth ? { width: field.containerWidth } : {}}>
											<LabelledTextInput
												placeHolder={field.placeHolder}
												name={field.name}
												type="text"
												value={this.state[field.name]}
												onChange={this.onChange(field.name)}
												style={field.inputWidth ? { width: field.inputWidth } : {}}
											/>
										</Column>
									);
								})}
								<Column style={{ width: '946px' }}>
									<a
										href="#"
										style={{ color: '#a1aeb7', textDecoration: 'none' }}
										onClick={this.lostActivationCode}
									>Lost your activation code?</a>
								</Column>
							</InputContainer>
						</CenteredContainer>
					): null}
					{!this.state.submitted ? (
						<Button
							text="CONTINUE"
							onSubmit={this.onSubmit} 
						/>
					) : null}
				</div>
			</Container>
		);
	}
};

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Activate/index.js